<app-base-modal
  [title]="'Редактирование ссылки профиля'"
>
  <div class="container">
    <form
      [formGroup]="formGroup"
      class="form-container"
    >
      @for (field of formFields; track $index) {
        @if (field.type === 'text') {
          <mat-form-field appearance="outline">
            <mat-label>{{ field.label }}</mat-label>
            <input
              matInput
              type="text"
              [formControlName]="field.fieldName"
            >
          </mat-form-field>
        } @else {
          <mat-form-field
            appearance="outline"
          >
            <mat-label>{{field.label}}</mat-label>
            <mat-select
              [formControlName]="field.fieldName"
              (selectionChange)="handleSelectChange($event)"
            >
              @for (option of profiles; track $index) {
                <mat-option [value]="option.id">
                  {{ option['url'] }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      }
    </form>
    <div class="buttons-container">
      <button
        mat-button
        color="primary"
        (click)="handleProfilesBloggerUpdate()"
      >
        Сохранить
      </button>
      <button
        mat-button
        color="warn"
        (click)="closeDialog('cancel')"
      >
        Отменить
      </button>
    </div>
  </div>
</app-base-modal>
